'use client';

import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';

import Button from '@/components/Button';
import Hamburger from '@/components/Hamburger';
import Navigation from '@/components/Navigation';
import worldIcon from 'public/icons/world-icon.svg';

import styles from './styles.module.scss';
import { Props } from './types';

const MenuMobile = ({
  isMobile,
  data,
  contactData,
  openSubMenu,
  closeSubMenu,
  openNavMenu,
  closeNavMenu,
  subMenuParent,
  isSubMenuOpened,
  isClosedMobileNav,
}: Props) => {
  const [isMobileMenuOpened, setIsMobileMenuOpened] = useState(false);
  const pathname = usePathname();

  const toogleMobileMenu = () => {
    setIsMobileMenuOpened(prevIsMobileMenuOpened => !prevIsMobileMenuOpened);
    closeSubMenu();
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpened(false);
  };

  useEffect(() => {
    setIsMobileMenuOpened(false);
  }, [pathname]);

  useEffect(() => {
    const disableBodyScroll = () => {
      document.documentElement.style.overflow = 'hidden';
    };

    const enableBodyScroll = () => {
      document.documentElement.style.overflow = 'auto';
    };

    if (isMobileMenuOpened) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }

    return () => {
      enableBodyScroll();
    };
  }, [isMobileMenuOpened]);

  const containerClass = classNames(
    styles.container,
    isMobileMenuOpened && styles.openedMenu,
  );

  const menuWrapperClass = classNames(
    styles.menuWrapper,
    isMobileMenuOpened && styles.opened,
  );

  const vendorButtonClass = classNames(styles.vendorButton, styles.paddings);
  const linksClass = classNames(styles.links, styles.paddings);

  return (
    <>
      <div className={containerClass}>
        <Hamburger
          toogleMenu={toogleMobileMenu}
          isMobileMenuOpened={isMobileMenuOpened}
        />
      </div>
      <div className={menuWrapperClass}>
        {isMobileMenuOpened && (
          <>
            <Navigation
              data={data}
              isMobile={isMobile}
              subMenuParent={subMenuParent}
              openSubMenu={openSubMenu}
              closeSubMenu={closeSubMenu}
              isSubMenuOpened={isSubMenuOpened}
              openNavMenu={openNavMenu}
              closeNavMenu={closeNavMenu}
              isClosedMobileNav={isClosedMobileNav}
              closeMobileMenu={closeMobileMenu}
            />
            {!isSubMenuOpened && (
              <div className={vendorButtonClass}>
                <Button
                  href={process.env.NEXT_PUBLIC_REGISTER_VENDOR_URL}
                  fullWidth
                  isOutline
                  isCapitalize
                  variant="primary"
                >
                  Sprzedawaj
                </Button>
              </div>
            )}
            <div className={linksClass}>
              <Link href="/foreign-customers" className={styles.linkItem}>
                <Image src={worldIcon} alt="World icon" width={16} />
                <p>Foreign customers</p>
              </Link>
              <div className={styles.contact}>
                {contactData.attributes &&
                  contactData.attributes.Kontakt.LinkiKontaktowe.map(item => {
                    return (
                      <Link
                        key={item.id}
                        href={item.URL}
                        className={styles.linkItem}
                      >
                        <Image
                          src={item.Ikona.data.attributes.url}
                          alt={
                            item.TekstAlternatywny
                              ? item.TekstAlternatywny
                              : item.Ikona.data.attributes.alternativeText
                          }
                          width={16}
                          height={16}
                        />
                        <p>{item.Nazwa}</p>
                      </Link>
                    );
                  })}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MenuMobile;
